var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "p-4" }, [
      _c(
        "div",
        { staticClass: "toolbar-card" },
        [
          _c("attendance-filter-bar", {
            attrs: {
              date: _vm.date,
              "id-class": _vm.idClass,
              "id-grade": _vm.idGrade,
              "id-group": _vm.idGroup,
              type: _vm.activeTab,
              "attendance-checked": _vm.attendanceChecked,
              "attendance-status": _vm.status,
            },
            on: { change: _vm.handleFilterChange },
          }),
          _c("div", { staticClass: "student-toolbar-divider" }),
          _c("attendance-footer-action", {
            attrs: {
              "dirty-count": _vm.dirtyIds.length,
              "is-saving": _vm.isSaving,
            },
            on: {
              save: _vm.handleSave,
              "export-excel-by-date": _vm.handleExportExcelByDay,
              "export-excel": _vm.handleOpenDialogOptionsExportExcel,
              constitutive: _vm.handleOpenConfigDialog,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "attendance-data-card" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "card-header-tabs" },
          [
            _c("attendance-tab-switcher", {
              on: { change: _vm.onChangeTab },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "card-body-table" },
          [
            _c("attendance-table", {
              attrs: {
                items: _vm.items,
                "attendance-map": _vm.attendanceMap,
                saving: _vm.isSaving,
                loading: _vm.isLoading,
              },
              on: {
                "row-update": _vm.onRowUpdate,
                update: _vm.handleView,
                "save-attendance": _vm.handleSaveAttendance,
                "selection-change": _vm.handleSelectionChange,
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _c(
      "div",
      [
        _c("attendance-update-action", {
          ref: "attendanceUpdateAction",
          attrs: {
            "dialog-visible": _vm.dialogVisible.update,
            type: _vm.activeTab,
          },
          on: { close: _vm.handleCloseDialogUpdate },
        }),
        _c("attendance-options-export-excel", {
          ref: "AttendanceOptionsExportExcel",
          attrs: {
            "dialog-visible": _vm.dialogVisible.optionsExportExcel,
            type: _vm.activeTab,
            "type-export": _vm.typeExportExcel,
          },
          on: {
            close: _vm.handleCloseOptionsExportExcel,
            "export-excel": _vm.handleExportExcel,
          },
        }),
        _c("attendance-config-dialog", {
          ref: "AttendanceConfigDialog",
          attrs: { "dialog-visible": _vm.dialogVisible.config },
          on: { "dialog-close": _vm.handleCloseSystemConfigSchool },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "card-title" }, [
        _vm._v("Danh sách điểm danh học sinh"),
      ]),
      _c("p", { staticClass: "card-subtitle" }, [
        _vm._v("Theo dõi thông tin điểm danh của học sinh"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }